import { ProjectAtlasWorkspace } from './atlas/ProjectAtlasWorkspace';
import { useSearchParams } from 'react-router';
import { PortfolioMapWorkspace } from '@/features/projects/PortfolioMapWorkspace';

export function ProjectMapPage() {
  const [params] = useSearchParams();
  if (params.get('portfolio') === '1') return <PortfolioMapWorkspace />;
  return <ProjectAtlasWorkspace />;
}
